function getlocationsData(){
  
  var jsonObj =[];
  //var geocoder = new google.maps.Geocoder();
  var markers = document.getElementsByTagName('marker');

  Array.prototype.forEach.call(markers, function(markerElem, i) {
    address = markerElem.getAttribute('address');
       var item = {}
        item ["lat"] = markerElem.getAttribute('lat');
        item ["lng"] = markerElem.getAttribute('lng');
        item ["address"] = markerElem.getAttribute('address');
        item ["info"] = markerElem.getAttribute('info');
        item ["locationtype"] = markerElem.getAttribute('locationtype');
    	item ["markerID"] = markerElem.getAttribute('data-markerid');
        jsonObj.push(item);
  });
  return jsonObj;
}
var markers_array = new Array();

function createSearchableMap(locations = getlocationsData(), locationTypes = ['all']) {
  initAutocomplete();
  //var locationTypes = [];  
  //var locations = getlocationsData();
  console.log(locations);
  var map;
  var bounds = new google.maps.LatLngBounds();
  var grayStyles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];
  var mapOptions = {mapTypeId: 'roadmap', styles: grayStyles};
  var markers = [];
  var infoWindowContent = [];
  
  
  var map = new google.maps.Map(document.getElementById('location-map'), mapOptions);
  
  map.setTilt(45);


  
  $.each($("#locationType input[name='locationtype']:checked"), function(){            
    locationTypes.push($(this).val());
  });
    locations.forEach(function(location) {
        if(locationTypes.includes(location.locationtype) && locationTypes.length){
          markers.push([location.lat, location.lng]);  
          infoWindowContent.push([''+ location.info +'']);

        } else if(locationTypes.includes('all')) {
          markers.push([location.lat, location.lng]);    
          infoWindowContent.push([''+ location.info +'']);
        }     
    });


  var infoWindow = new google.maps.InfoWindow(), marker, i;
  
  // Place the markers on the map
  
  for( i = 0; i < markers.length; i++ ) {
    var position = new google.maps.LatLng(markers[i][0], markers[i][1]);
    bounds.extend(position);
    marker = new google.maps.Marker({
      position: position,
      map: map,
      //title: markers[i][0]
    });
    
    // Add an infoWindow to each marker, and create a closure so that the current
    // marker is always associated with the correct click event listener
    google.maps.event.addListener(marker, 'click', (function(marker, i) {
      return function() {
        infoWindow.setContent(infoWindowContent[i][0]);
        infoWindow.open(map, marker);
      }
    })(marker, i));

    // Only use the bounds to zoom the map if there is more than 1 location shown
		if (locations.length > 1) {
			map.fitBounds(bounds);
		} else {
			var center = new google.maps.LatLng(locations[0].lat, locations[0].lng);
			map.setCenter(center);
			map.setZoom(15);
		}
    markers_array.push(marker);
  }
  
   $(document).on("click",".location-marker-link",function() {
     	google.maps.event.trigger(markers_array[$(this).data('markerid')], 'click');
    });
}

function filterLocations() {
  var allLocations = getlocationsData();
  var userLatLng;
  var geocoder = new google.maps.Geocoder();
  var userAddress = document.getElementById('userAddress').value.replace(/[^a-z0-9\s]/gi, '');
  var maxRadius = parseInt(jQuery( "#maxRadius option:selected" ).val(), 10);
  var locationTypes = [];
  $.each($("#locationType input[name='locationtype']:checked"), function(){            
      locationTypes.push($(this).val());
  });
  
  if (userAddress && maxRadius) {
    userLatLng = getLatLngViaHttpRequest(userAddress);
  } 

  function getLatLngViaHttpRequest(address) {
    // Set up a request to the Geocoding API
    var addressStripped = address.split(' ').join('+');
    var key = 'AIzaSyCXNl4u8AnIuPCslbJIw79l4mmU84GsnLc';
    var request = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + addressStripped + '&key=' + key;

    // Call the Geocoding API using jQuery GET, passing in the request and a callback function 
    // which takes one argument "data" containing the response
    $.get( request, function( data ) {
      var searchResultsAlert = document.getElementById('location-search-alert');
      // console.log('request to googleapis');
      // console.log(data);

      // Abort if there is no response for the address data
      if (data.status === "ZERO_RESULTS") {
        searchResultsAlert.innerHTML = "Sorry, '" + address + "' seems to be an invalid address.";
        return;
      } else {
      	searchResultsAlert.innerHTML = "";
      }

      var userLatLng = new google.maps.LatLng(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng);
      var filteredLocations = allLocations.filter(isWithinRadius);
      
      if (filteredLocations.length > 0) {
        
        createSearchableMap(filteredLocations, locationTypes);
        createListOfLocations(filteredLocations, locationTypes);
        //searchResultsAlert.innerHTML = 'No Locations within ' + maxRadius + ' miles of ' + userAddress + ':';
      } else {
        console.log("nothing found!");
        document.getElementById('locations-near-you').innerHTML = '';
        searchResultsAlert.innerHTML = 'Sorry, no locations were found within '+ maxRadius + ' miles of ' + userAddress + '.';
      }

      function isWithinRadius(location) {
        var locationLatLng = new google.maps.LatLng(location.lat, location.lng);
        var distanceBetween = google.maps.geometry.spherical.computeDistanceBetween(locationLatLng, userLatLng);
       //console.log(distanceBetween);

        return convertMetersToMiles(distanceBetween) <= maxRadius;
      }
    });  
  }
}

function convertMetersToMiles(meters) {
  return (meters * 0.000621371);
}


function createListOfLocations(locations, locationTypes) {
  var locationsList = document.getElementById('locations-near-you');
  
  
  var userLatLng;
  var address = document.getElementById('userAddress').value.replace(/[^a-z0-9\s]/gi, '');
  
  var addressStripped = address.split(' ').join('+');
  var key = 'AIzaSyCXNl4u8AnIuPCslbJIw79l4mmU84GsnLc';
  var request = 'https://maps.googleapis.com/maps/api/geocode/json?address=' + addressStripped + '&key=' + key;
  $.get( request, function( data ) {
      userLatLng = new google.maps.LatLng(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng);      
      
       // Clear any existing locations from the previous search first
        locationsList.innerHTML = '';

        var locationTypes = [];
        $.each($("#locationType input[name='locationtype']:checked"), function(){            
            locationTypes.push($(this).val());
        });  
        infoWindow = new google.maps.InfoWindow;
    	
    	var locations_array=[];
    	locations.forEach( function(location,index) {
        	var locationLatLng = new google.maps.LatLng(location.lat, location.lng);
          	var distanceBetween = google.maps.geometry.spherical.computeDistanceBetween(locationLatLng, userLatLng);
          	var disfromaddress = convertMetersToMiles(distanceBetween);
          	location.disfromaddress=disfromaddress;
          	
            locations_array.push(location);
        });
        locations_array.sort(function(a, b) {
          return a.disfromaddress - b.disfromaddress;
      	});   	
    	
    
    	locations_array.forEach( function(location) {
          
          if(locationTypes.includes(location.locationtype) && Array.isArray(locationTypes) && locationTypes.length){
            var specificLocation = document.createElement('div');
            var locationInfo = location.info;
            locationInfo += location.disfromaddress.toFixed(2) + ' mi';
            
            specificLocation.setAttribute("class", 'location-marker-link');
            specificLocation.setAttribute("data-markerid", location.markerID);
            specificLocation.innerHTML = locationInfo;
            locationsList.appendChild(specificLocation);
            jQuery(".firstload").remove();
          } else if(locationTypes.includes('all')){
           
            var specificLocation = document.createElement('div');
            var locationInfo = location.info;
            locationInfo += '<p class="distance">' + location.disfromaddress.toFixed(2) + ' mi' + '</p>';
            
            specificLocation.setAttribute("class", 'location-marker-link');
            specificLocation.setAttribute("data-markerid", location.markerID);
            specificLocation.innerHTML = locationInfo;
            locationsList.appendChild(specificLocation);
            jQuery(".firstload").remove();
          }
        });

    });
}
$( document ).ready(function() {
  $('#submitLocationSearch').on('click', function(e) {
    e.preventDefault();
    if($("input[type='checkbox'][name='locationtype']:checked").length == 0){
    	$("#alllocation").prop('checked', true);
    }

    if(!$('#userAddress').val()){
      alert("Please add address");
      $("#userAddress").focus();
    } else {
      filterLocations();
    }
  });
});

// autocomplete code start from here


var placeSearch, autocomplete;

var componentForm = {
  street_number: 'short_name',
  route: 'long_name',
  locality: 'long_name',
  administrative_area_level_1: 'short_name',
  country: 'long_name',
  postal_code: 'short_name'
};

function initAutocomplete() {
  // Create the autocomplete object, restricting the search predictions to
  // geographical location types.
  autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('userAddress'), {types: ['geocode']});

  // Avoid paying for data that you don't need by restricting the set of
  // place fields that are returned to just the address components.
  autocomplete.setFields(['address_component']);
}

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
function geolocate() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function(position) {
      var geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      var circle = new google.maps.Circle(
          {center: geolocation, radius: position.coords.accuracy});
      autocomplete.setBounds(circle.getBounds());
    });
  }
}
